import { applyGroupSizeFilter } from './applyGroupSizeFilter';
import { mostCompatibleGroupSize } from './groupSIze';
import { resolvedEventBookingType, TDR } from 'tdr-common';

/** Tables to use for event calendar/slot availability (respects min guest count on param events). */
export function getEventCalendarTables(
	event: TDR.Event,
	tables: TDR.Table[],
	linkedTable?: TDR.Table
): TDR.Table[] {
	const evKind = resolvedEventBookingType(event);
	if (evKind === 'table') {
		return linkedTable ? [linkedTable] : [];
	}
	const groupSize = resolveEventBookNowGroupSize(event, tables);
	return applyGroupSizeFilter(tables, groupSize);
}

export function resolveEventBookNowGroupSize(
	event: TDR.Event,
	tables: TDR.Table[],
	linkedTable?: TDR.Table
): number {
	const minFromEvent = event.condition?.value?.minGuestCount;
	if (typeof minFromEvent === 'number' && minFromEvent >= 1) {
		return minFromEvent;
	}

	if (linkedTable && typeof linkedTable.minGuests === 'number' && linkedTable.minGuests >= 1) {
		return linkedTable.minGuests;
	}

	const compat = mostCompatibleGroupSize(tables);
	if (compat >= 1) {
		return compat;
	}

	return 2;
}
